
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "resize-box": "resize-box-a9329763",
    "transitional": "transitional-a9329763",
    "resizeBox": "resize-box-a9329763"
};
exports.styleSource = ".resize-box-a9329763{position:relative;box-sizing:border-box;overflow:hidden;transition:all .2s ease}.transitional-a9329763>div{box-sizing:content-box;height:fit-content;padding:1px}";
exports.default = exports.styles;
            
module.moduleType = "style";
